import { useEffect, useState } from 'react';
import { API } from '../service/ProductsService';
import { useAuth } from '../utils/AuthContext';
import { favorites, useFavoriteIds, parseFavorites, DROP_BADGE } from '../utils/favoritesStore';
import ProductRow from './ProductRow';

// "ירד מחיר!" בעמוד הראשי (מעל הדשבורד, SearchTab): מועדפים של המשתמש שהמחיר שלהם באתר החנות ירד בשבוע האחרון
// (spGetFavorites עם onlyDrops). למשתמש לא מחובר / בלי הוזלות — לא מוצג בכלל.
const SHOW_FIRST = 3;

const s = {
  card:    { background: 'linear-gradient(180deg, #effaf2 0%, #fff 60%)', border: '1px solid #aceebb', borderRadius: 14, padding: 16, marginBottom: 20 },
  head:    { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10, flexWrap: 'wrap', marginBottom: 12 },
  title:   { margin: 0, fontSize: 18, fontWeight: 700, color: '#116329' },
  sub:     { margin: '2px 0 0', fontSize: 13, color: '#59636e' },
  list:    { display: 'flex', flexDirection: 'column', gap: 10 },
  more:    { alignSelf: 'center', padding: '8px 16px', fontSize: 14, fontWeight: 600, border: '1px solid #1a7f37', borderRadius: 10, background: '#fff', color: '#1a7f37' },
};

const FavoriteDrops = () => {
  const { user } = useAuth();
  const favoriteIds = useFavoriteIds();
  const [data, setData] = useState(null);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (!user) { setData(null); return undefined; }
    let alive = true;
    API.getFavorites(true)
      .then((resp) => { if (alive && resp?.[0]?.[0]?.code === 0) setData(parseFavorites(resp)); })
      .catch(() => { /* בלי הכרטיס — העמוד עובד */ });
    return () => { alive = false; };
  }, [user]);

  // הסרה מהמועדפים (❤) — נעלם מיד
  const items = (data?.items || []).filter((x) => !favorites.isLoaded() || favoriteIds.has(x.id));
  if (!items.length) return null;

  const shown = showAll ? items : items.slice(0, SHOW_FIRST);

  return (
    <section style={s.card} aria-labelledby="drops-title">
      <div style={s.head}>
        <div>
          <h2 id="drops-title" style={s.title}>⬇ ירד מחיר על המועדפים שלך</h2>
          <p style={s.sub}>המחיר באתר החנות ירד בשבוע האחרון</p>
        </div>
      </div>
      <div style={s.list}>
        {shown.map((item) => (
          <ProductRow key={item.id} item={item} stores={data.stores} prices={data.pricesByItem[item.id] || {}}
                      badge={DROP_BADGE} drops={data.dropsByItem[item.id]} />
        ))}
        {items.length > shown.length && (
          <button type="button" style={s.more} onClick={() => setShowAll(true)}>הצגת כל {items.length} המוצרים שהוזלו</button>
        )}
      </div>
    </section>
  );
};

export default FavoriteDrops;
